import { defineComponent, computed } from "vue";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "toggle",
  props: {
    value: { type: Boolean },
    label: { default: void 0 },
    disabled: { type: Boolean },
    medium: { type: Boolean },
    ariaLabel: { default: void 0 },
    outlinePrimary: { type: Boolean },
    normalFontSize: { type: Boolean }
  },
  emits: ["input"],
  setup(__props, { expose, emit: emits }) {
    const props = __props;
    const containerClass = computed(() => {
      return {
        "toggle--disabled": props.disabled,
        "toggle--active": props.value,
        "toggle--medium": props.medium,
        "toggle--small-label": !props.normalFontSize
      };
    });
    const controlsClasses = computed(() => {
      return {
        "btn--outline-primary": props.outlinePrimary,
        "btn--outline": !props.outlinePrimary,
        "btn--disabled": props.disabled
      };
    });
    const change = () => {
      if (props.disabled)
        return;
      emits("input", !props.value);
    };
    expose({ containerClass, change });
    return { __sfc: true, props, emits, containerClass, controlsClasses, change };
  }
});
export {
  _sfc_main as default
};
